const ADD_APPROVAL = 'ADD_APPROVAL';
const ADD_MESSAGE = 'ADD_MESSAGE';
const CLOSE_APPROVAL = 'CLOSE_APPROVAL';
const CLOSE_MESSAGE = 'CLOSE_MESSAGE';

export { ADD_APPROVAL, ADD_MESSAGE, CLOSE_APPROVAL, CLOSE_MESSAGE };
